export const getImportFileError = (file: File): string | null => (
  file.name.toLowerCase().endsWith('.xlsx')
    ? null
    : 'O arquivo não está no formato correto. Selecione uma planilha .xlsx.'
);
